import React, { useState, useEffect, useCallback, useRef } from 'react';
import Layout from 'Component/Layouts/layout';
import {
  Box,
  TextField,
  FormLabel,
  FormControl,
  Grid,
  Button,
  Typography,
  Card,
  CardContent,
  Autocomplete,
  Switch,
  CircularProgress,
  Modal,
  ButtonGroup,
  Paper,
  Chip,
  Divider,
  IconButton,
} from '@mui/material';
import { School, Group, Upload, Download, Assignment, CheckCircle } from '@mui/icons-material';
import deleteIcon from 'assets/delete-icon.png';
import useApiCaller from 'hooks/apiCaller';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { debounce } from 'lodash';
import * as XLSX from 'xlsx';

const CourseMaping = () => {
  const apiCaller = useApiCaller();
  const [checked, setChecked] = useState(false);
  const [allDepartment, setAllDepartment] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [allEmployee, setAllEmployee] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchString, setSearchString] = useState('');
  const [selectedCourse, setSelectedCourse] = useState({});
  const [getAllCourses, setGetAllCourses] = useState([]);
  const [excelData, setExcelData] = useState(null);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleGetAllCourses = async () => {
    try {
      const response = await apiCaller.get('/super-user/getAllCourse');
      if (response) {
        setGetAllCourses(response?.data?.data?.courses);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAllDepartment = async () => {
    try {
      const response = await apiCaller.get('/super-user/getDepartments');
      if (response) {
        setAllDepartment(response?.data?.data?.department);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAllEmployeeByDepartId = async () => {
    const data = {
      departments: selectedDepartment.map((val) => val.departmentId),
    };
    try {
      const response = await apiCaller.post('/super-user/getEmployee', data);
      if (response) {
        setAllEmployee(response?.data?.data?.employee);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const unassignCourse = async (apiCaller, payload) => {
    try {
      const response = await apiCaller.post('/super-user/unassignCourse', payload);
      return response;
    } catch (error) {
      console.error('Error unassigning course:', error);
      throw error;
    }
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
    setSelectedDepartment([]);
  };

  const handleDelete = (id) => {
    setSelectedDepartment(selectedDepartment.filter((val) => val.departmentId !== id));
  };

  const handleEmpDelete = (id) => {
    setSelectedEmployees(selectedEmployees.filter((val) => val._id !== id));
  };

  const fetchEmployees = async (search) => {
    if (search.trim().length > 0) {
      try {
        const data = { searchString: search };
        const response = await apiCaller.post('/super-user/getEmployee', data);
        if (response) {
          setAllEmployee(response?.data?.data?.employee);
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      setAllEmployee([]);
    }
  };

  const debouncedFetchEmployees = useCallback(
    debounce((search) => {
      fetchEmployees(search);
    }, 300),
    []
  );

  const handleSearchChange = (event) => {
    setSearchString(event.target.value);
    debouncedFetchEmployees(event.target.value);
  };

  const handleSaveMappedData = async () => {
    setIsLoading(true);
    console.log('employees', selectedEmployees);
    const data = {
      courseId: selectedCourse?._id,
      assignedTo: !checked ? 'department' : 'employee',
      departments: selectedDepartment.map((val) => val.departmentId),
      employees: checked && selectedEmployees.map((val) => val.employeeId),
    };
    try {
      const response = await apiCaller.post('/super-user/courseMapping', data);
      if (response) {
        setIsLoading(false);
        toast.success('Course Mapped Successfully!', {
          theme: 'colored',
        });
      }
    } catch (error) {
      setIsLoading(false);
      toast.error('Something Went Wrong!', {
        theme: 'colored',
      });
    }
  };

  const handleDeleteMappedData = async () => {
    setIsLoading(true);
    const data = {
      courseId: selectedCourse?._id,
      assignedTo: !checked ? 'department' : 'employee',
      departments: !checked ? selectedDepartment.map((val) => val.departmentId) : [],
      employees: checked ? selectedEmployees.map((val) => val.employeeId) : [],
    };

    try {
      await unassignCourse(apiCaller, data);
      setIsLoading(false);
      toast.success('Course Unassigned Successfully!', {
        theme: 'colored',
      });
      handleClose();
    } catch (error) {
      setIsLoading(false);
      toast.error('Unassignment Failed!', {
        theme: 'colored',
      });
      handleClose();
    }
  };

  useEffect(() => {
    getAllDepartment();
    handleGetAllCourses();
  }, []);

  useEffect(() => {
    if (checked) {
      getAllEmployeeByDepartId();
    }
  }, [selectedDepartment.length]);
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      console.log('File selected:', file);
      // You can add logic here to process the file, such as uploading or reading its contents
      const reader = new FileReader();

      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 2 });
        // {`${val.employeeId}-${val.employeeName}`}
        jsonData.map((elem) => {
          elem['employeeId'] = elem['Employee Code'];
          elem['employeeName'] = elem['Emp Name'];
        });
        console.log('Parsed JSON:', jsonData);

        //setExcelData(jsonData);
        setSelectedEmployees([...selectedEmployees, ...jsonData]);
      };

      reader.readAsArrayBuffer(file);
    }
  };

  const handleBulkUploadClick = () => {
    fileInputRef?.current?.click(); // Trigger the file input on button click
  };
  return (
    <Layout>
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          p: { xs: 2, md: 3 },
        }}
      >
        {/* Professional Header */}
        <Box
          sx={{
            mb: 2,
            background: '#ffffff',
            borderRadius: '8px',
            p: 2,
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e2e8f0',
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            gap={1}
          >
            <Box>
              <Typography
                variant="h5"
                fontWeight="600"
                sx={{
                  color: '#1e293b',
                  mb: 0.25,
                }}
              >
                Course Mapping
              </Typography>
              <Typography variant="body2" sx={{ color: '#64748b', fontWeight: '400' }}>
                Assign courses to departments and employees across your organization
              </Typography>
            </Box>
            <Box display="flex" gap={2} alignItems="center">
              <Button
                variant="outlined"
                startIcon={<Download />}
                sx={{
                  borderRadius: '12px',
                  px: 3,
                  py: 1.5,
                  fontWeight: '600',
                  textTransform: 'none',
                  borderColor: '#10b981',
                  color: '#10b981',
                  '&:hover': {
                    borderColor: '#059669',
                    backgroundColor: 'rgba(16, 185, 129, 0.04)',
                  },
                }}
                href="/assets/empUploadCourseTemplate.xlsx"
                download
              >
                Download Template
              </Button>
              <Button
                variant="contained"
                startIcon={<Upload />}
                onClick={handleBulkUploadClick}
                disabled={!checked}
                sx={{
                  background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                  borderRadius: '12px',
                  px: 3,
                  py: 1.5,
                  fontWeight: '600',
                  textTransform: 'none',
                  boxShadow: '0 4px 14px 0 rgba(59, 130, 246, 0.3)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 8px 25px 0 rgba(59, 130, 246, 0.4)',
                  },
                }}
              >
                Bulk Upload Employees
              </Button>
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                accept=".xlsx, .xls"
                onChange={handleFileChange}
              />
            </Box>
          </Box>
        </Box>

        {/* Main Content */}
        <Card
          sx={{
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            mb: 3,
          }}
        >
          <CardContent sx={{ p: 2 }}>
            {/* Form Section */}
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h5"
                fontWeight="700"
                sx={{
                  color: '#1e293b',
                  mb: 3,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                <Assignment sx={{ color: '#3b82f6' }} />
                Course Assignment
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <FormLabel
                      sx={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#374151',
                        mb: 1,
                      }}
                    >
                      Select Course
                    </FormLabel>
                    <Autocomplete
                      size="small"
                      value={selectedCourse?.courseTitle}
                      onChange={(event, newValue) => setSelectedCourse(newValue)}
                      options={getAllCourses}
                      getOptionLabel={(option) => option.courseTitle}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '12px',
                              '& fieldset': {
                                borderColor: '#e2e8f0',
                              },
                              '&:hover fieldset': {
                                borderColor: '#3b82f6',
                              },
                              '&.Mui-focused fieldset': {
                                borderColor: '#3b82f6',
                                borderWidth: 2,
                              },
                            },
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6} sx={{ display: 'flex', alignItems: 'center' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      p: 2,
                      background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
                      borderRadius: '12px',
                      border: '1px solid #e2e8f0',
                    }}
                  >
                    <Typography sx={{ fontSize: 16, fontWeight: 600, color: '#374151' }}>
                      Mapped By:
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 16,
                        color: checked ? '#64748b' : '#3b82f6',
                        fontWeight: checked ? '400' : '600',
                      }}
                    >
                      Department
                    </Typography>
                    <Switch
                      checked={checked}
                      onChange={handleChange}
                      sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                          color: '#3b82f6',
                        },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                          backgroundColor: '#3b82f6',
                        },
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: 16,
                        color: checked ? '#3b82f6' : '#64748b',
                        fontWeight: checked ? '600' : '400',
                      }}
                    >
                      Employee
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              <Grid container spacing={3} sx={{ mt: 2 }}>
                {!checked && (
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <FormLabel
                        sx={{
                          fontSize: 16,
                          fontWeight: 600,
                          color: '#374151',
                          mb: 1,
                        }}
                      >
                        Select Department
                      </FormLabel>
                      <Autocomplete
                        multiple
                        size="small"
                        value={selectedDepartment}
                        onChange={(event, newValue) => setSelectedDepartment(newValue)}
                        options={allDepartment}
                        getOptionLabel={(option) => option.departmentName}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                '& fieldset': {
                                  borderColor: '#e2e8f0',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#3b82f6',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor: '#3b82f6',
                                  borderWidth: 2,
                                },
                              },
                            }}
                          />
                        )}
                        disabled={checked}
                      />
                    </FormControl>
                  </Grid>
                )}

                {checked && (
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <FormLabel
                        sx={{
                          fontSize: 16,
                          fontWeight: 600,
                          color: '#374151',
                          mb: 1,
                        }}
                      >
                        Select Employee
                      </FormLabel>
                      <Autocomplete
                        multiple
                        size="small"
                        value={selectedEmployees}
                        onChange={(event, newValue) => setSelectedEmployees(newValue)}
                        options={allEmployee}
                        getOptionLabel={(option) => `${option.employeeId}-${option.employeeName}`}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            value={searchString}
                            onChange={handleSearchChange}
                            placeholder="Search by Employee ID or Name"
                            disabled={!checked}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                '& fieldset': {
                                  borderColor: '#e2e8f0',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#3b82f6',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor: '#3b82f6',
                                  borderWidth: 2,
                                },
                              },
                            }}
                          />
                        )}
                        sx={{
                          maxHeight: '200px',
                          overflowY: 'auto',
                        }}
                        disabled={!checked}
                      />
                    </FormControl>
                  </Grid>
                )}
              </Grid>

              {/* Selected Items Display */}
              <Grid container spacing={3} sx={{ mt: 2 }}>
                {!checked && (
                  <Grid item xs={12} md={6}>
                    <Typography sx={{ fontSize: 16, fontWeight: 600, color: '#374151', mb: 2 }}>
                      Selected Departments
                    </Typography>
                    <Card
                      sx={{
                        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                        border: '1px solid #e2e8f0',
                        borderRadius: '12px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        boxShadow:
                          '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                      }}
                    >
                      {selectedDepartment.length ? (
                        selectedDepartment.map((val) => (
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: 2,
                              borderBottom: '1px solid #f1f5f9',
                              '&:last-child': {
                                borderBottom: 'none',
                              },
                            }}
                            key={val.departmentId}
                          >
                            <Typography sx={{ color: '#374151', fontWeight: '500' }}>
                              {val.departmentName}
                            </Typography>
                            <IconButton
                              onClick={() => handleDelete(val.departmentId)}
                              sx={{
                                color: '#ef4444',
                                '&:hover': {
                                  backgroundColor: 'rgba(239, 68, 68, 0.1)',
                                },
                              }}
                            >
                              <img src={deleteIcon} alt="delete-icon" width="20" height="20" />
                            </IconButton>
                          </Box>
                        ))
                      ) : (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 4,
                            textAlign: 'center',
                          }}
                        >
                          <Typography sx={{ color: '#64748b', fontSize: 14 }}>
                            No departments selected. Selected departments will appear here.
                          </Typography>
                        </Box>
                      )}
                    </Card>
                  </Grid>
                )}

                {checked && (
                  <Grid item xs={12} md={6}>
                    <Typography sx={{ fontSize: 16, fontWeight: 600, color: '#374151', mb: 2 }}>
                      Selected Employees
                    </Typography>
                    <Card
                      sx={{
                        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                        border: '1px solid #e2e8f0',
                        borderRadius: '12px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        boxShadow:
                          '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                      }}
                    >
                      {selectedEmployees.length ? (
                        selectedEmployees.map((val) => (
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: 2,
                              borderBottom: '1px solid #f1f5f9',
                              '&:last-child': {
                                borderBottom: 'none',
                              },
                            }}
                            key={val._id}
                          >
                            <Typography sx={{ color: '#374151', fontWeight: '500' }}>
                              {`${val.employeeId}-${val.employeeName}`}
                            </Typography>
                            <IconButton
                              onClick={() => handleEmpDelete(val._id)}
                              sx={{
                                color: '#ef4444',
                                '&:hover': {
                                  backgroundColor: 'rgba(239, 68, 68, 0.1)',
                                },
                              }}
                            >
                              <img src={deleteIcon} alt="delete-icon" width="20" height="20" />
                            </IconButton>
                          </Box>
                        ))
                      ) : (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 4,
                            textAlign: 'center',
                          }}
                        >
                          <Typography sx={{ color: '#64748b', fontSize: 14 }}>
                            No employees selected. Selected employees will appear here.
                          </Typography>
                        </Box>
                      )}
                    </Card>
                  </Grid>
                )}
              </Grid>

              {/* Action Buttons */}
              <Box sx={{ mt: 4, display: 'flex', gap: 2, justifyContent: 'center' }}>
                <Button
                  variant="contained"
                  size="large"
                  disabled={!selectedCourse?.courseTitle}
                  startIcon={<CheckCircle />}
                  sx={{
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    borderRadius: '12px',
                    px: 4,
                    py: 1.5,
                    fontWeight: '600',
                    textTransform: 'none',
                    fontSize: '16px',
                    boxShadow: '0 4px 14px 0 rgba(16, 185, 129, 0.3)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 8px 25px 0 rgba(16, 185, 129, 0.4)',
                    },
                    '&:disabled': {
                      background: '#e2e8f0',
                      color: '#94a3b8',
                      transform: 'none',
                      boxShadow: 'none',
                    },
                  }}
                  onClick={handleSaveMappedData}
                >
                  {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Assign Course'}
                </Button>

                <Button
                  variant="contained"
                  color="error"
                  size="large"
                  disabled={
                    !(
                      selectedCourse?.courseTitle &&
                      (checked ? selectedEmployees.length > 0 : selectedDepartment.length > 0)
                    )
                  }
                  startIcon={<Group />}
                  sx={{
                    borderRadius: '12px',
                    px: 4,
                    py: 1.5,
                    fontWeight: '600',
                    textTransform: 'none',
                    fontSize: '16px',
                    boxShadow: '0 4px 14px 0 rgba(239, 68, 68, 0.3)',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 8px 25px 0 rgba(239, 68, 68, 0.4)',
                    },
                    '&:disabled': {
                      background: '#e2e8f0',
                      color: '#94a3b8',
                      transform: 'none',
                      boxShadow: 'none',
                    },
                  }}
                  onClick={handleOpen}
                >
                  {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Unassign Course'}
                </Button>
              </Box>

              {/* Confirmation Modal */}
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                    borderRadius: '20px',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                    p: 4,
                    border: '1px solid #e2e8f0',
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight="600"
                    sx={{
                      color: '#1e293b',
                      textAlign: 'center',
                      mb: 3,
                    }}
                  >
                    Confirm Unassignment
                  </Typography>
                  <Typography
                    sx={{
                      color: '#64748b',
                      textAlign: 'center',
                      mb: 4,
                    }}
                  >
                    Do you really want to unassign this course?
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                    <Button
                      onClick={handleDeleteMappedData}
                      variant="contained"
                      color="error"
                      sx={{
                        borderRadius: '12px',
                        px: 3,
                        py: 1,
                        fontWeight: '600',
                        textTransform: 'none',
                      }}
                    >
                      Yes, Unassign
                    </Button>
                    <Button
                      onClick={handleClose}
                      variant="outlined"
                      sx={{
                        borderRadius: '12px',
                        px: 3,
                        py: 1,
                        fontWeight: '600',
                        textTransform: 'none',
                        borderColor: '#e2e8f0',
                        color: '#64748b',
                        '&:hover': {
                          borderColor: '#3b82f6',
                          color: '#3b82f6',
                          backgroundColor: 'rgba(59, 130, 246, 0.04)',
                        },
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Layout>
  );
};

export default CourseMaping;
